import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StatementOfAccountTemplateHdrModel } from "../../../../../../models/aggregates/erp/statement-of-account/statement-of-account-template-hdr.model";

@Injectable({ providedIn: "root" })
export class StatementOfAccountTemplateHdrService extends BaseApiTemplateService<StatementOfAccountTemplateHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
    "template-hdrs/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
      "template-hdrs/backoffice-ep";
    this.httpClient = theHttp;
  }
}
